import angular from 'angular'
import statisticsDrawBack from './statisticsDrawBack'

export default angular
    .module('app.statisticsDrawBack', [])
    .directive('statisticsDrawBack', statisticsDrawBack)
    .name



// WEBPACK FOOTER //
// ./src/components/statisticsDrawBack/index.js